import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import Instruction from './Instruction';

const Instructions = ({ ...props }) => {
  const { instructions } = props;
  return (
    <Grid container direction="column" spacing={1}>
      {Object.entries(instructions).length > 0 &&
        instructions.map((instruction, index) => (
          <Instruction
            key={index}
            icon={instruction.iconURL}
            text={instruction.text}
          />
        ))}
    </Grid>
  );
};

Instructions.propTypes = {
  instructions: PropTypes.array,
};

export default Instructions;
